import React from 'react'
import '../Style/HeaderItemList.css'
import ArrowDown from '../Logos/caret-down.svg'
import { Lightning_Section, Fan_Section, Switch_Section, Protector_Section, Cable_Section, Other_Section, Tasviri_Section } from '../Components/Helpers/Section_Helper'
import { Link } from 'react-router-dom'

function Sections({Section}) {
    return (
        <>
            <div className='section-list'>
                {Section === "lightning" ? Lightning_Section.map((Items, key) => {
                    return <div className='section'>
                        <div className='title'>{Items.title}<img src={ArrowDown} alt=''/></div>
                        <div className='section-rows'>
                            {Items.childs.map((childsitem, key) => {
                                return <Link to={childsitem.link} className='sections-item-rows'>{childsitem.name}</Link>
                            })}
                        </div>
                    </div>
                }) : null}
                {Section === "fan" ? Fan_Section.map((Items, key) => {
                    return <div className='section'>
                        <div className='title'>{Items.title}<img src={ArrowDown} alt=''/></div>
                        <div className='section-rows'>
                            {Items.childs.map((childsitem, key) => {
                                return <Link to={childsitem.link} className='sections-item-rows'>{childsitem.name}</Link>
                            })}
                        </div>
                    </div>
                }) : null}
                {Section === "switch" ? Switch_Section.map((Items, key) => {
                    return <div className='section'>
                        <div className='title'>{Items.title}<img src={ArrowDown} alt=''/></div>
                        <div className='section-rows'>
                            {Items.childs.map((childsitem, key) => {
                                return <Link to={childsitem.link} className='sections-item-rows'>{childsitem.name}</Link>
                            })}
                        </div>
                    </div>
                }) : null}
                {Section === "protector" ? Protector_Section.map((Items, key) => {
                    return <div className='section'>
                        <div className='title'>{Items.title}<img src={ArrowDown} alt=''/></div>
                        <div className='section-rows'>
                            {Items.childs.map((childsitem, key) => {
                                return <Link to={childsitem.link} className='sections-item-rows'>{childsitem.name}</Link>
                            })}
                        </div>
                    </div>
                }) : null}
                {Section === "cable" ? Cable_Section.map((Items, key) => {
                    return <div className='section'>
                        <div className='title'>{Items.title}<img src={ArrowDown} alt=''/></div>
                        <div className='section-rows'>
                            {Items.childs.map((childsitem, key) => {
                                return <Link to={childsitem.link} className='sections-item-rows'>{childsitem.name}</Link>
                            })}
                        </div>
                    </div>
                }) : null}
                {Section === "other" ? Other_Section.map((Items, key) => {
                    return <div className='section'>
                        <div className='title'>{Items.title}<img src={ArrowDown} alt=''/></div>
                        <div className='section-rows'>
                            {Items.childs.map((childsitem, key) => {
                                return <Link to={childsitem.link} className='sections-item-rows'>{childsitem.name}</Link>
                            })}
                        </div>
                    </div>
                }) : null}
                {Section === "tasviri" ? Tasviri_Section.map((Items, key) => {
                    return <div className='section'>
                        <div className='title'>{Items.title}<img src={ArrowDown} alt=''/></div>
                        <div className='section-rows'>
                            {Items.childs.map((childsitem, key) => {
                                return <Link to={childsitem.link} className='sections-item-rows'>{childsitem.name}</Link>
                            })}
                        </div>
                    </div>
                }) : null}
            </div>
        </>
    )
}

export default Sections